import React from 'react';
import { ERouteLinks } from 'models/route';
import { useTranslations } from 'hooks/useTranslations';
import { usePermission } from 'hooks/usePermission';
import { EPermission } from 'models/permissions';
import { EIconTypes } from 'constants/Icons';
import ElementsComponent, { IElements } from './elementsComponent';

const SystemSettings = () => {
  const { t } = useTranslations();
  const { hasPermissions } = usePermission();
  const elements: IElements[] = [];

  if (hasPermissions([EPermission.MANAGE_SETTINGS])) {
    elements.push({
      url: ERouteLinks.AuthenticationSetup,
      title: t('authenticationSetup.header'),
    });
  }
  if (hasPermissions([EPermission.MANAGE_CUSTOM_FIELDS])) {
    elements.push({
      url: ERouteLinks.CustomFields,
      title: t('customFields.header'),
    });
  }
  if (hasPermissions([EPermission.MANAGE_SETTINGS])) {
    elements.push({
      url: ERouteLinks.DateTimeSetup,
      title: t('dateTimeSetup.header'),
    });
  }
  if (hasPermissions([EPermission.MANAGE_DICTIONARIES])) {
    elements.push({
      url: ERouteLinks.Dictionaries,
      title: t('dictionaries.header'),
    });
  }

  if (hasPermissions([EPermission.MANAGE_SETTINGS])) {
    elements.push({
      url: ERouteLinks.LogosSetupPage,
      title: t('logosSetup.header'),
    });
    elements.push({
      url: ERouteLinks.SystemFieldsConfigurationPage,
      title: t('systemFieldsConfiguration.header'),
    });
    elements.push({
      url: ERouteLinks.DocumentsGeneratingSetupPage,
      title: t('documentsGeneratingSetup.header'),
    });
    elements.push({
      url: ERouteLinks.UnitsCurrencySetupPage,
      title: t('unitsCurrencySetup.header'),
    });
  }

  return (
    <ElementsComponent
      title={t('systemSettings.header')}
      iconType={EIconTypes.systemSettings}
      elements={elements}
    />
  );
};

export default SystemSettings;
